// One row of the org-chart bulk editor (components/OrgChartModal.js Edit
// tab) — a person + a native "reports to" select. Seeded per-instance via
// childrenAs: 'state' (see OrgChartModal.js), so `s` here is the row's own
// {partyId, name, avatar, email}, and `s.root` still reaches the shared
// app state (_orgChartWorking lives there, not on the row).
export const OrgChartEditRow = {
  flow: 'x',
  align: 'center',
  gap: 'Z',
  padding: 'Y -',

  // Built-in Avatar is a bare `<img>` (extends smbls.Avatar) — an empty
  // `src` renders the browser's broken-image glyph rather than falling
  // back gracefully. Most Party rows have no avatar image, so this needs
  // the same image-or-initials treatment PersonCard.js's PcAvatar uses
  // (without its presence-dot overlay, not relevant here).
  PersonAvatar: {
    align: 'center center',
    boxSize: 'C',
    round: '50%',
    color: 'title',
    fontSize: 'Y2',
    fontWeight: '700',
    position: 'relative',
    overflow: 'hidden',
    background: 'overlayStrong',
    AvatarImg: {
      tag: 'img',
      // `if:`, never `hide:` — a display:none <img> still FETCHES its src;
      // non-URL avatar values 404ed against the origin (same class as the
      // IntranetRows plate, fixed 2026-09-01). Guarded src as the belt.
      if: (el, s) => typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar),
      position: 'absolute',
      inset: '0',
      width: '100%',
      height: '100%',
      src: (el, s) =>
        typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar) ? s.avatar : null,
      alt: (el, s) => s.name || '',
      style: { objectFit: 'cover' }
    },
    Initials: {
      tag: 'span',
      hide: (el, s) => typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar),
      text: (el, s) => {
        const parts = String(s.name || '')
          .trim()
          .split(/\s+/)
          .filter(Boolean)
        if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
        return String(s.name || '?')
          .slice(0, 2)
          .toUpperCase()
      }
    }
  },
  Name: {
    flex: '1',
    tag: 'span',
    fontSize: 'Z2',
    fontWeight: '700',
    color: 'title',
    text: (el, s) => s.name || ''
  },

  SelectField: {
    minWidth: 'F',
    padding: 'V A',
    round: 'D',

    // Native <select>. `value:` is the reactive, diffed DOMQL prop (FA511 —
    // el.node writes bypass diffing and get overwritten by the next
    // render); `childProps.attr.selected` below keeps each generated
    // <option> in sync too, since a native select's displayed value can
    // depend on both.
    Select: {
      name: (el, s) => `org-chart-manager-${s.partyId}`,
      value: (el, s) => (s.root?._orgChartWorking || {})[s.partyId] || '',
      onChange: (e, el, s) => el.call('orgChartSetWorking', s, s.partyId, e.target.value || null),
      childrenAs: 'props',
      children: (el, s) => {
        const options = [{ value: '', text: el.call('polyglot', 'workspace.orgChart.noManager') }]
        for (const p of el.call('orgChartDirectory')) {
          if (p.partyId === s.partyId) continue
          options.push({ value: p.partyId, text: p.name })
        }
        return options
      },
      childProps: {
        tag: 'option',
        attr: {
          selected: (el, s) => ((s.root?._orgChartWorking || {})[s.partyId] || '') === el.value
        }
      }
    }
  }
}
